import * as React from 'react';
import { useTheme } from '../../../theme';
import { useIsMobile } from '../../../utils';
const SectionWrapper = ({ title, error, headerButton, children }) => {
    const { SectionWrapper: css } = useTheme('TravellerForm');
    const isMobile = useIsMobile();
    const showHeaderButton = headerButton && isMobile;
    const showTitleWrapper = !!title || showHeaderButton;
    const hasChildren = React.Children.toArray(children).length > 0;
    return (React.createElement("div", { className: css.sectionWrapper },
        showTitleWrapper && (React.createElement("div", { className: css.sectionWrapper__title_wrapper },
            !!title && (React.createElement("div", null,
                React.createElement("div", { className: css.sectionWrapper__title }, title),
                !!error && React.createElement("div", { className: css.sectionWrapper__error }, error))),
            showHeaderButton && headerButton)),
        hasChildren && isMobile && showTitleWrapper && React.createElement("div", { className: css.line }),
        hasChildren && React.createElement("div", { className: css.sectionWrapper__content }, children)));
};
export default SectionWrapper;
